import { Component, OnInit } from '@angular/core';
import { hasOnePermission, InternalSettingsService } from '../../services/internal-settings/internal-settings.service';
import { UserService } from '../../services/user/user.service';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { ExternalSettings, WebLogo } from '../../services/external-settings/external-settings.interface';
import { Router } from '@angular/router';
import { InternalSettings, PermissionList, Permissions } from '../../services/internal-settings/internal-settings.interface';
import { environment } from 'src/environments/environment';
import { HelpDeskService } from 'src/app/business/help-desk/help-desk.service';
import { SupportCenterService } from 'src/app/business/support-center/support-center.service';

@Component({
    selector: 'app-top-header',
    templateUrl: './top-header.component.html',
    styleUrls: ['./top-header.component.less'],
    standalone: false
})
export class TopHeaderComponent implements OnInit {

  public environment = environment;
  public showQr: boolean = false;
  public hasHelpDesk: boolean = false;

  loggedIn : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  logo!: WebLogo;
  src: string = '';
  externalSettings!: ExternalSettings;
  internalSettings!: InternalSettings;
  UIUtilityService: any = UIUtilityService;

  constructor(private srvUser : UserService,
              private srvIs: InternalSettingsService,
              private srvEs: ExternalSettingsService, 
              private router: Router,
              private srvHelpDesk: HelpDeskService,
              private srvSupport: SupportCenterService,) {

    this.srvUser.isLoggedIn$.subscribe((loggedIn: boolean) => {
      this.loggedIn.next(loggedIn);
    })
   }

  ngOnInit(): void {
    forkJoin([
      this.srvIs.getCurrentSettings(),
      this.srvEs.externalSettings$
    ]).subscribe(([is, es]) => {

      this.internalSettings = is;
      this.externalSettings = es;

      this.logo = es.web.logo;
      if (this.logo) {
        this.src = this.logo.image + '?lastmod' + this.logo.size;
      }      

      let module = this.externalSettings.globalVariables.isModuleEnabledQRCode;
      let permission = hasOnePermission([PermissionList.SCAN_MERCHANT_QR_CODE, PermissionList.SCAN_PEER_QR_CODE, PermissionList.SCAN_ORDER_QR_CODE], is.permissions);
      this.showQr = module && permission;
    })

    this.srvSupport.showHelpDesk$.subscribe((show: boolean)=>{
      this.hasHelpDesk = show;
    })

  }

  logoff() {
    if (this.hasHelpDesk) {
      this.srvHelpDesk.closeTicket(true).subscribe(()=>{
        this.srvUser.logoff();
      });
    } else {
      this.srvUser.logoff();
    }
  }  

  onLogoClick() {
    if (this.srvUser.isLoggedIn$.value) {

      // Route to Dashboard
      this.router.navigateByUrl("/dashboard");
    }
    else {
      this.srvUser.logoff();
    }
  }

  onInfoClick() {
    let node = {
      "externalSettings": this.externalSettings,
      "internalSettings": this.internalSettings
    }
    navigator.clipboard.writeText(JSON.stringify(node, null, 2));
  }

  getVersion() {
    let versionMatch = /\d+/.exec(window.document.location.pathname);
    let version = versionMatch ? versionMatch[0] : '2.0';
    return version;
  }
}


